/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @version 1.0.0
 * @since 1.0.0
 */

import { ICommonNotification } from '../../types/common/notification';

export const initTranslationNotification: ICommonNotification = {
    errorServer: '',
    goToLabel: '',
};
